import type { AuthLogin, AuthPassword } from "~/@types/store/auth";
import type { Usuario } from "~/@types/schemas/usuario";
import { API } from "~/composables/api";

class _API {
  get = async (token: string) => {
    return await API.getOne(`/auth`, { headers: { 'Authorization': token } });
  }
  
  login = async (payload: AuthLogin) => {
    return await API.post<{ token: string, usuario: Usuario }>(`/auth`, { body: payload });
  }

  senha = async (payload: AuthPassword) => {
    return await API.put<{ token: string, usuario: Usuario }>(`/auth/senha`, { body: payload });
  }
}

export const AuthApi = new _API();